import { Bookmark } from "lucide-react";
import "./SaveBadge.css";

export const SaveBadge = ({ hasSaved, onToggle }) => {
  return (
    <div
      className={`katch-replay-card__save-badge ${hasSaved ? "saved" : "unsaved"}`}
      onClick={(e) => {
        e.stopPropagation();
        onToggle?.();
      }}
    >
      {hasSaved ? (
        <Bookmark size={20} className="saved-icon" fill="currentColor" />
      ) : (
        <Bookmark size={20} className="unsaved-icon" />
      )}
    </div>
  );
};
